import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl, FormattedMessage } from 'react-intl';

import env from 'Env';
import { supportUrl } from 'Config/lang';
import EmailSubscribe from 'Components/EmailSubscribe/EmailSubscribe';
import imgixConfig from 'Config/imgix';

import 'Components/EmailSubscribe/EmailSubscribeBox.scss';

const messages = defineMessages({
  button_text: {
    id: 'email_subscribe_box.button.text',
    defaultMessage: 'Sign up now',
  },
});

const EmailSubscribeBox = ({ intl, subscribed, context }) => {
  const { formatMessage } = intl;

  if (subscribed) return false;

  const bgImgSrc = `${env.cdnUrl}/assets/backgrounds/email/email-banner-bg-horizon-2.jpg`;

  return (
    <section className="EmailSubscribeBox">
      <div className="EmailSubscribeBox__content">
        <div className="EmailSubscribeBox__title">
          <FormattedMessage
            id="email_subscribe_box.title"
            defaultMessage="Join our newsletter"
          />
        </div>

        <div className="EmailSubscribeBox__intro">
          <FormattedMessage
            id="email_subscribe_box.introduction"
            defaultMessage="Sign up now to get the following benefits emailed direct to your inbox."
          />
        </div>

        <div className="EmailSubscribeBox__points">
          <div className="EmailSubscribeBox__point">
            <div className="EmailSubscribeBox__point__leftSlash" />
            <div className="EmailSubscribeBox__point__middle">
              <FormattedMessage
                id="email_subscribe_box.point.subscriber-offers"
                defaultMessage="Subscriber-only offers"
              />
            </div>
            <div className="EmailSubscribeBox__point__rightSlash" />
          </div>
          <div className="EmailSubscribeBox__point">
            <div className="EmailSubscribeBox__point__leftSlash" />
            <div className="EmailSubscribeBox__point__middle">
              <FormattedMessage
                id="email_subscribe_box.point.coupons-giveaways"
                defaultMessage="Exclusive coupons & giveaways"
              />
            </div>
            <div className="EmailSubscribeBox__point__rightSlash" />
          </div>
          <div className="EmailSubscribeBox__point">
            <div className="EmailSubscribeBox__point__leftSlash" />
            <div className="EmailSubscribeBox__point__middle">
              <FormattedMessage
                id="email_subscribe_box.point.incredible-deals"
                defaultMessage="Incredible game deals"
              />
            </div>
            <div className="EmailSubscribeBox__point__rightSlash" />
          </div>
        </div>

        <div className="EmailSubscribeBox__buttonContainer">
          <EmailSubscribe
            singleOptIn
            context={context}
            buttonText={formatMessage(messages.button_text)}
          />
        </div>

        <div className="EmailSubscribeBox__smallprint">
          <FormattedMessage
            id="email_subscribe_box.smallprint"
            defaultMessage="You can unsubscribe via the newsletter at any time. By subscribing to our newsletter you agree to our {link}."
            values={{
              link: <a href={`${supportUrl()}/articles/115005052465-Privacy-Policy`}>
                <FormattedMessage
                  id="email_subscribe_box.smallprint.link"
                  defaultMessage="Privacy Policy"
                />
              </a>,
            }}
          />
        </div>
      </div>

      <div className="EmailSubscribeBox__background">
        <img
          srcSet={`
            ${bgImgSrc}?${imgixConfig}&w=840&h=920&fit=crop,
            ${bgImgSrc}?${imgixConfig}&w=630&h=690&fit=crop,
            ${bgImgSrc}?${imgixConfig}&w=420&h=460&fit=crop
          `}
          src={`${bgImgSrc}?${imgixConfig}&w=840&h=920&fit=crop`}
          alt="Join Our Newsletter | Background"
        />
      </div>
      <div className="EmailSubscribeBox__background__overlay" />
    </section>
  );
};

const mapStateToProps = ({
  auth: { email_newsletter: emailNewsletter },
}) => ({
  subscribed: emailNewsletter,
});

export default connect(mapStateToProps, null)(injectIntl(EmailSubscribeBox));

EmailSubscribeBox.propTypes = {
  context: PropTypes.string,
};

EmailSubscribeBox.defaultProps = {
  context: '',
};
